import React from 'react';

const ProgressBar = ({
  currentStep = 1,
  totalSteps = 3,
  steps = [],
  className = ''
}) => {
  const percentage = (currentStep / totalSteps) * 100;

  return (
    <div className={`w-full ${className}`}>
      {/* Progress Bar */}
      <div className="relative">
        <div className="h-2 bg-accent-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-all duration-300"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>

      {/* Step Labels */}
      {steps.length > 0 && (
        <div className="flex justify-between mt-3">
          {steps.map((step, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber <= currentStep;
            const isCurrent = stepNumber === currentStep;

            return (
              <div
                key={index}
                className="flex flex-col items-center"
                style={{ width: `${100 / totalSteps}%` }}
              >
                <div
                  className={`
                    w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold mb-1
                    ${isActive
                      ? 'bg-primary text-white'
                      : 'bg-accent-200 text-accent-500'
                    }
                    ${isCurrent ? 'ring-2 ring-primary ring-offset-2' : ''}
                    transition-all duration-200
                  `}
                >
                  {stepNumber}
                </div>
                <span
                  className={`text-xs text-center ${
                    isActive ? 'text-primary font-medium' : 'text-accent-500'
                  }`}
                >
                  {step}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
